import LoadingSpinner from 'components/Shared/LoadingSpinner';
import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import { buttonCss } from './styles';

export enum ButtonState {
  normal = 'normal',
  thinking = 'thinking',
  disabled = 'disabled',
}

export enum ButtonColor {
  gray = 'gray',
  transparent = 'transparent',
}

interface ButtonProps {
  normalText?: string;
  disabledText?: string;
  state?: ButtonState;
  onClick?: () => void;
  buttonColor?: string;
  className?: string;
  children?: string;
  disabled?: boolean;
  type?: 'submit' | 'reset' | undefined;
}

export function LargeButton({ className, ...props }: ButtonProps): JSX.Element {
  return (
    <>
      <BaseButton {...props} className={classNames('large-button', className)} />
    </>
  );
}

export function SmallButton({ className, ...props }: ButtonProps): JSX.Element {
  return (
    <>
      <BaseButton {...props} className={classNames('small-button', className)} />
    </>
  );
}

export function BaseButton({
  children,
  normalText = children,
  disabledText = normalText,
  state = ButtonState.normal,
  onClick = (): void => {},
  buttonColor,
  className,
  disabled,
  type,
  ...props
}: ButtonProps & ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  const filteredOnClick = (): void => {
    if (state === ButtonState.normal) {
      onClick();
    }
  };

  return (
    <>
      <button
        className={classNames(
          state,
          'base-button',
          buttonColor ? `${buttonColor}-button` : '',
          className
        )}
        onClick={filteredOnClick}
        disabled={state === ButtonState.disabled || disabled}
        type={type}
        aria-label={normalText}
        role="button"
        aria-busy={state === ButtonState.thinking}
        aria-disabled={state === ButtonState.disabled || disabled}
        {...props}
      >
        {state === ButtonState.normal && normalText}
        {state === ButtonState.thinking && (
          <LoadingSpinner containerSize={28} isWhite={!buttonColor} spinnerSize={28} />
        )}
        {state === ButtonState.disabled && disabledText}
      </button>
      <style jsx>{buttonCss}</style>
    </>
  );
}
